import merge from 'deepmerge';

import { isDeviceType, DEVICE_TYPE_GROUP_DESKTOP, DEVICE_TYPE_TABLET, DEVICE_TYPE_PHONE } from '@cube/blocks';


const overwriteMerge = (destinationArray, sourceArray, options) => sourceArray;
export function getPageConfig(pageConfig, device) {
	if (isDesktop(device)) device = 'desktop';
	if (pageConfig[device]) pageConfig = merge(pageConfig, pageConfig[device], { arrayMerge: overwriteMerge });
	return pageConfig;
}

export function isDesktop(device) {
	return isDeviceType(device, DEVICE_TYPE_GROUP_DESKTOP);
}

export function getDeviceTemplate({ device, Desktop, Tablet, Phone }) {
	return (isDeviceType(device, DEVICE_TYPE_TABLET) && Tablet) ||
		(isDeviceType(device, DEVICE_TYPE_PHONE) && Phone) ||
		Desktop;
}
